import { showLoadingIndicator, stopLoadingIndicator, SUCCESS_DEFAULT, FAILURE_DEFAULT } from '../modules/auth';
import { SHOW_DIALOG } from '../../constants/commonConstants';

export default function clientMiddleware(client) {
  return ({dispatch, getState}) => {
    return next => action => {
      if (typeof action === 'function') {
        return action(dispatch, getState);
      }
      const { promise, type, ...rest } = action; // eslint-disable-line no-redeclare
      if (!promise) {
        return next(action);
      }

      dispatch(showLoadingIndicator());
      //const [REQUEST, SUCCESS = SUCCESS_DEFAULT, FAILURE = FAILURE_DEFAULT] = type;
      next({...rest, type: type});
      const actionPromise = promise(client);
      actionPromise.then(
        (result) => {
          dispatch(stopLoadingIndicator());
          if (result.statusCode === 401) {
            next({...rest, result, type: SHOW_DIALOG});
          }
          if (result.status === true || result.status === "true") {
            next({...rest, result, type:`${type}_SUCCESS`});
          } else {
            next({...rest, result, type: `${type}_FAILURE`});
          }
        },
        (error) => {
          dispatch(stopLoadingIndicator());
          next({...rest, error, type: `${type}_FAILURE`});
        }
      ).catch((error)=> {
        next({...rest, error, type: `${type}_FAILURE`});
      });

      return actionPromise;
    };
  };
}
